import { render, staticRenderFns } from "./GamesPermissions.container.vue?vue&type=template&id=78c83534&scoped=true&"
import script from "./GamesPermissions.container.vue?vue&type=script&lang=js&"
export * from "./GamesPermissions.container.vue?vue&type=script&lang=js&"
import style0 from "./GamesPermissions.container.vue?vue&type=style&index=0&id=78c83534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c83534",
  null
  
)

export default component.exports